<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>ユーザー設定</template>
    </PageHeader>

    <template>
      <v-tabs v-model="tab" grow show-arrows>
        <v-tab>パスワード変更</v-tab>
        <v-tab>アイコン設定</v-tab>
      </v-tabs>
    </template>

    <ChangePassword v-if="tab === 0" />

    <Thumbnail v-if="tab === 1" />
  </v-container>
</template>

<script>
import ChangePassword from '@/components/pages/UserSettings/ChangePassword.vue';
import Thumbnail from '@/components/pages/UserSettings/Thumbnail.vue';

export default {
  components: {
    ChangePassword,
    Thumbnail,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'ユーザー設定',
          route: 'UserSettings',
        },
      ],

      tab: 0,
    };
  },
  created() {},
};
</script>
